import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { ICampaignReportRequest, ICampaignReportResponse } from '../models/models'

export class CampaignReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReport/CampaignReport',
      requesterInfo,
    })
  }

  public async campaignReport(request: ICampaignReportRequest): Promise<ICampaignReportResponse> {
    return await this.postAsync<ICampaignReportResponse>(request)
  }
}
